import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=0e6f404a&scoped=true&"
import script from "./emoji.vue?vue&type=script&lang=js&"
export * from "./emoji.vue?vue&type=script&lang=js&"
import style0 from "./emoji.vue?vue&type=style&index=0&id=0e6f404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f404a",
  null
  
)

export default component.exports